<template>
    <div style="max-width: 420px">
        <v-data-iterator
            :items="listItems"
            :items-per-page="-1"
            hide-default-footer
        >
            <template v-slot:header>
                <v-toolbar
                    class="my-2"
                    light
                    flat
                    dense
                >
                    <v-checkbox
                        ref="selectAllCheckbox"
                        v-model="selectAll"
                        dense
                        hide-details
                        indeterminate
                        @click="selectAllCheckBox()"
                    >
                        <template v-slot:label>
                            <span class="black--text text--darken-3">
                                Select All
                            </span>
                        </template>
                    </v-checkbox>
                </v-toolbar>
            </template>
            <template v-slot:default="{ items }">
                <draggable
                    tag="ul"
                    :list="items"
                    class="list-group pa-0"
                    handle=".handle"
                    @change="updateOrder($event, items)"
                >
                    <li
                        v-for="item in items"
                        :key="item.type"
                        class="list-group-item align-center px-1"
                    >
                        <v-icon class="handle mr-1">
                            mdi-drag-vertical
                        </v-icon>
                        <v-list-item-action>
                            <v-checkbox
                                v-model="item.selected"
                                dense
                                @click="selectSingleCheckBox(item)"
                            />
                        </v-list-item-action>
                        <span
                            class="font-weight-bold pl-1"
                        >
                            {{ item.label }}
                        </span>
                        <v-spacer />
                        <ColorMenu
                            :item="item"
                            @updateItemColor="updateItemColor"
                        />
                    </li>
                    <v-divider />
                </draggable>
            </template>
        </v-data-iterator>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import ColorMenu from './colorMenu';
export default {
    components: {
        draggable,
        ColorMenu,
    },
    props: {
        colors: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectAll: false,
            selected: [],
        };
    },
    computed: {
        listItems: {
            get() {
                return this.colors;
            },
            set() {
                this.$emit('updateColors', this.listItems);
            },
        },
    },
    methods: {
        selectAllCheckBox() {
            var checked = [];
            this.listItems = this.listItems.map((type) => {
                type.selected = this.selectAll;
                if (this.selectAll) {
                    checked.push(type);
                }
                return type;
            });
            this.selected = checked;
        },
        selectSingleCheckBox(item) {
            if (item.selected ? this.selected.push(item) : this.selected.splice(this.selected.indexOf(item), 1));
            if (this.selected.length === this.listItems.length ? this.selectAll = true : this.selectAll = false);
        },
        updateOrder(event) {
            this.listItems.splice(
                event.moved.newIndex,
                0,
                this.listItems.splice(event.moved.oldIndex, 1)[0]
            );
        },
        updateItemColor(item, color) {
            this.listItems.forEach(element => {
                if (element.type === item.type) {
                    element.color = color.color;
                    element.class = color.class;
                }
            });
        },
    },
};
</script>
<style scoped>
.v-icon--disabled {
    color: transparent !important;
}
.list-group {
    background-color: #f5f7fa;
}
.list-group-item {
    display: flex;
    border-top: 1px solid #e0e0e0;
}
.handle:active,
.handle:hover {
    cursor: move;
}
</style>